import React, { useState } from 'react';
import './Tasks.css';

const Tasks = () => {
  const [tasks, setTasks] = useState([]);

  return (
    <div className="tasks-container">
      <h2>Task Management</h2>
      <div className="tasks-content">
        <p>Task management component coming soon...</p>
      </div>
    </div>
  );
};

export default Tasks; 